import classNames from 'classnames';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { H4 } from 'UIComponents/elements/headings';

// @ts-expect-error Library not yet migrated

import ProfessorList from '../LessonPage/ProfessorList';
import { ExternalLearningContentBanner } from '../../features/learningContent';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const BASE_CLASS_NAME = 'lesson-information';
const LessonOverview = ({
  description,
  className = '',
  professors = [],
  hubId,
  handleOrganisationUrlClick
}) => {
  return /*#__PURE__*/_jsxs("div", {
    className: classNames(BASE_CLASS_NAME, className),
    children: [hubId && /*#__PURE__*/_jsx(ExternalLearningContentBanner, {
      className: "m-bottom-6 m-top-2",
      hubId: hubId
    }), /*#__PURE__*/_jsx(H4, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.lessonInformation.header"
      })
    }), /*#__PURE__*/_jsx("p", {
      children: description
    }), !!professors.length && /*#__PURE__*/_jsx(ProfessorList, {
      className: `${BASE_CLASS_NAME}__professors`,
      handleOrganisationUrlClick: handleOrganisationUrlClick,
      i18nHeading: "learningCenter.lessonInformation.professors",
      professors: professors
    })]
  });
};
export default LessonOverview;